import SentralPortalModalCloseToast from "./SentralPortalModalCloseToast";
export default SentralPortalModalCloseToast;
